"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLevelEnabled = exports.logError = exports.logWarn = exports.logInfo = exports.logDebug = void 0;
function logDebug(logger, ...data) {
    if (checkIfFunction(logger, 'debug')) {
        logger.debug(...data);
    }
    else if (logger) {
        // logger level is switched off by default
        console.debug(...data);
    }
}
exports.logDebug = logDebug;
function logInfo(logger, ...data) {
    if (checkIfFunction(logger, 'info')) {
        logger.info(...data);
    }
    else {
        console.log(...data);
    }
}
exports.logInfo = logInfo;
function logWarn(logger, ...data) {
    if (checkIfFunction(logger, 'warn')) {
        logger.warn(...data);
    }
    else {
        console.warn(...data);
    }
}
exports.logWarn = logWarn;
function logError(logger, ...data) {
    if (checkIfFunction(logger, 'error')) {
        logger.error(...data);
    }
    else {
        console.error(...data);
    }
}
exports.logError = logError;
function isLevelEnabled(logger, level) {
    if (logger === undefined) {
        return undefined;
    }
    let levelEnabled = false;
    if (!checkIfFunction(logger, 'isLevelEnabled')) {
        levelEnabled = logger.isLevelEnabled(level);
    }
    else if (!levelEnabled && level in logger) {
        const loggerLevel = logger.level;
        levelEnabled = searchIfLabelIsEnabled(loggerLevel, level);
    }
    return levelEnabled;
}
exports.isLevelEnabled = isLevelEnabled;
function checkIfFunction(logger, functionName) {
    return logger !== undefined && typeof logger[functionName] === 'function';
}
function searchIfLabelIsEnabled(currentLevel, desiredLevel) {
    const levels = ['error', 'warn', 'info', 'debug', 'trace'];
    currentLevel = currentLevel.toLowerCase();
    desiredLevel = desiredLevel.toLowerCase();
    const currentLevelIndex = levels.indexOf(currentLevel);
    const desiredLevelIndex = levels.indexOf(desiredLevel);
    return currentLevelIndex !== -1 && currentLevelIndex >= desiredLevelIndex;
}
//# sourceMappingURL=logging.js.map